import React from 'react'
import {TISTORY} from "../../../constants/Service"

function FilteredText({filter}) {
  switch(filter) {
    case 'responsive':
      return '반응형'
    case '1':
      return '1단형'
    case '2':
      return '2단형'
    case '3':
      return '3단형'
    case 'EDITABLE_MENU':
      return '메뉴 지원'
    case 'SKIN_WIZARD':
      return '스킨위자드 지원'
    default:
      return ''
  }
}

function FilteredButton({filter, onReset}) {
  function handleClick(e) {
    e.stopPropagation()
    e.preventDefault()
    onReset()
  }

  if (filter != 'all') {
    return (
      <>
        <a href="#" className="link_back" onClick={handleClick}>
          <span className="ico_blog ico_back">필터/정렬 초기화</span>
        </a>
        <span className="txt_result"><FilteredText filter={filter}/> </span>
      </>
    )
  } else {
    return null
  }
}

export default function SkinListTitle({filter, size, history, onReset}) {

  function handleSkinAdd() {
    history.push('/design/skin/add')
  }

  return (
    <h3 className="tit_cont">
      <FilteredButton filter={filter} onReset={onReset} />
      스킨 목록
      <span className="txt_count">{size}</span>

      {window.Config.service === TISTORY &&
        <label className="lab_btn lab_add">
          스킨 등록
          <input type="button" className="btn_g" value="스킨 등록" onClick={handleSkinAdd} />
        </label>
      }
    </h3>
  )
}
